import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AboutCompany.css';
import { Section } from '../Section';
import { Subtitle } from '../Subtitle';
import { Factoids } from '../Factoids';
import { IFactoid } from '../../types/builder';
import { Title } from '../Title';

export interface IAboutCompanyProps {
  description: React.ReactNode;
  constructionZone: string;
  materials?: string;
  factoids: IFactoid[];
}

export const AboutCompany: React.FC<IAboutCompanyProps> = ({ description, constructionZone, materials, factoids }) => {
  return (
    <Section dataName="AboutCompany">
      <div className={styles['container']}>
        {!!factoids.length && (
          <div className={styles['factoids']}>
            <Factoids items={factoids} />
          </div>
        )}
        <div className={styles['main']}>
          <Title>О строительной компании</Title>
          <div className={styles['description']}>
            <ArticleParagraph1 as="div">{description}</ArticleParagraph1>
          </div>
          <Subtitle>Регионы работы</Subtitle>
          <ArticleParagraph1>{constructionZone}</ArticleParagraph1>
          {materials && (
            <>
              <Subtitle>Материалы</Subtitle>
              <ArticleParagraph1>{materials}</ArticleParagraph1>
            </>
          )}
        </div>
      </div>
    </Section>
  );
};
